import { fromJS, Record } from 'immutable';
import { UserAccount } from './sub-models/user-account.model';
import { Challenge } from './sub-models/challenge.model';
import { generateKeys, generateSchema, setInModel } from 'i2g-ng-utils';

const SCHEMA = Object.freeze({
  AUTHENTICATION_RESULT: UserAccount,
  CHALLENGE: Challenge,
});
const RECORD = generateSchema(SCHEMA);
const KEYS: any = generateKeys(SCHEMA);

export class LoginResult extends Record(RECORD) {
  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.AUTHENTICATION_RESULT,
        value: props.get(KEYS.AUTHENTICATION_RESULT)
          ? new UserAccount(this.userAccount)
          : null,
      },
      {
        key: KEYS.CHALLENGE,
        value: props.get(KEYS.CHALLENGE) ? new Challenge(this.challenge) : null,
      },
    ]) as LoginResult;
  }

  get userAccount(): UserAccount | null {
    return this.get(KEYS.AUTHENTICATION_RESULT);
  }

  get challenge(): Challenge | null {
    return this.get(KEYS.CHALLENGE);
  }
}
